import { PopoverPanel as HeadlessPopoverPanel } from '@headlessui/react';

import { ia } from 'lib/helpers/utility';

import PopoverOptions from '../Options/PopoverOptions';

import { getPanelClasses } from './lib/getClasses';

const PopoverPanel = ({
  isFixed,
  handlePanelRef,
  panelRef,
  onScroll,
  panelClassName,
  position,
  panelFixedPosition,
  options,
  children,
  close,
  // Options props
  optionsGroupBy,
  optionGroupLabelClassName,
  hoveredIndexes,
  handleMouseEnter,
  handleMouseLeave,
  handleOptionClick,
  activeOptionRef,
  submenuRefs,
  text,
  customButton,
  optionIconSize,
  optionIconColor,
  iconsShade,
  optionArrowIcon,
  optionArrowIconStroke,
  optionActiveIcon,
  optionArrowColor,
  optionIconNoColor
}) => {
  const renderOptions = (options, level = 1, handleClose, parentPath = '') => (
    <PopoverOptions
      options={options}
      level={level}
      handleClose={handleClose}
      parentPath={parentPath}
      optionsGroupBy={optionsGroupBy}
      optionGroupLabelClassName={optionGroupLabelClassName}
      hoveredIndexes={hoveredIndexes}
      handleMouseEnter={handleMouseEnter}
      handleMouseLeave={handleMouseLeave}
      handleOptionClick={handleOptionClick}
      activeOptionRef={activeOptionRef}
      submenuRefs={submenuRefs}
      text={text}
      customButton={customButton}
      optionIconSize={optionIconSize}
      optionIconColor={optionIconColor}
      iconsShade={iconsShade}
      optionArrowIcon={optionArrowIcon}
      optionArrowIconStroke={optionArrowIconStroke}
      optionActiveIcon={optionActiveIcon}
      optionArrowColor={optionArrowColor}
      position={position}
      renderOptions={renderOptions}
      optionIconNoColor={optionIconNoColor}
    />
  );

  const renderChildren = (close) => {
    if (ia(options)) return renderOptions(options, 1, close);
    if (typeof children === 'function') {
      return (
        <div className="flex flex-col overflow-hidden">{children({ closePopover: close })}</div>
      );
    }
    if (children) {
      return <div className="flex flex-col overflow-hidden">{children}</div>;
    }
    return null;
  };

  return (
    <HeadlessPopoverPanel
      ref={isFixed ? handlePanelRef : panelRef}
      portal={isFixed}
      onScroll={onScroll}
      className={getPanelClasses({ isFixed, position, options, panelClassName })}
      style={isFixed ? panelFixedPosition : {}}>
      {renderChildren(close)}
    </HeadlessPopoverPanel>
  );
};

export default PopoverPanel;
